/**
 * The area's three routes, gathered.
 *
 * PLURAL `.routes.tsx` because this file exports an ARRAY of `RouteObject`s;
 * each per-route folder exports exactly one and is named `.route.tsx`
 * (singular). The importer knows the shape from the name, which is what the
 * naming rule exists to buy.
 *
 * `/plans`, `/checkout` and `/subscription` are three separate rows of the
 * sitemap and three separate URLs — the `subscription/` bucket is file
 * organisation, not a URL prefix. Nesting them under a path segment would
 * change the contract; the aggregator only saves the router table three
 * imports.
 */
import type { RouteObject } from 'react-router-dom';

import { checkoutRoute } from './checkout/checkout.route';
import { plansRoute } from './plans/plans.route';
import { subscriptionStatusRoute } from './status/status.route';

export const subscriptionRoutes: RouteObject[] = [plansRoute, checkoutRoute, subscriptionStatusRoute];
